import { AxiosResponse } from 'axios';
import api from './api';

interface TranscriptionResponse {
  id: number;
  audio_file_path: string | null;
  transcription_text: string;
  transcricao_ia: string | null;
  notes: string | null;
  patient_name: string | null;
  type: string;
  status: string;
  created_at: string;
  updated_at: string;
}

export interface Transcription {
  id: number;
  audioFilePath: string | null;
  transcriptionText: string;
  transcricaoIa: string | null;
  notes: string | null;
  patientName: string | null;
  type: string;
  status: string;
  createdAt: string;
}

const mapTranscriptionFromResponse = (data: TranscriptionResponse): Transcription => {
  console.log('Mapeando transcrição:', data);
  console.log('Data criação:', data.created_at, typeof data.created_at);
  const mapped = {
    id: data.id,
    audioFilePath: data.audio_file_path,
    transcriptionText: data.transcription_text,
    transcricaoIa: data.transcricao_ia,
    notes: data.notes,
    patientName: data.patient_name,
    type: data.type,
    status: data.status,
    createdAt: data.created_at
  };
  console.log('Transcrição mapeada:', mapped);
  return mapped;
};

export const TranscriptionService = {
  async list(): Promise<Transcription[]> {
    console.log('Buscando transcrições...');
    const response: AxiosResponse<TranscriptionResponse[]> = await api.get('/transcriptions');
    console.log('Resposta do servidor:', response.data);
    const mappedData = response.data.map(mapTranscriptionFromResponse);
    console.log('Dados mapeados:', mappedData);
    return mappedData;
  },

  async get(id: number): Promise<Transcription> {
    const response: AxiosResponse<TranscriptionResponse> = await api.get(`/transcriptions/${id}`);
    return mapTranscriptionFromResponse(response.data);
  },

  async update(id: number, field: string, value: string): Promise<Transcription> {
    // Converter camelCase para snake_case
    const fieldMap: { [key: string]: string } = {
      'transcriptionText': 'transcription_text',
      'transcricaoIa': 'transcricao_ia',
      'patientName': 'patient_name',
      'audioFilePath': 'audio_file_path',
      'notes': 'notes',
      'type': 'type',
      'status': 'status'
    };

    const snakeCaseField = fieldMap[field];
    const response: AxiosResponse<TranscriptionResponse> = await api.put(`/transcriptions/${id}`, { [snakeCaseField]: value });
    return mapTranscriptionFromResponse(response.data);
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/transcriptions/${id}`);
  },

  async format(id: number): Promise<Transcription> {
    const response: AxiosResponse<TranscriptionResponse> = await api.post(`/transcriptions/${id}/format`);
    return mapTranscriptionFromResponse(response.data);
  }
};
